/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_League_FootnoteInputs */

const ja_playdata_pricing_league_footnote = /** @type {(inputs: Playdata_Pricing_League_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10日分の統計は基本料金80,000円に含まれます。11日目以降は追加料金3,500円/日が加算されます。`)
};

const en_playdata_pricing_league_footnote = /** @type {(inputs: Playdata_Pricing_League_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data for 10 days is included in the base fee of ¥80,000. From the 11th day onwards, a charge of ¥3,500/day is added.`)
};

/**
* | output |
* | --- |
* | "Data for 10 days is included in the base fee of ¥80,000. From the 11th day onwards, a charge of ¥3,500/day is added." |
*
* @param {Playdata_Pricing_League_FootnoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_league_footnote = /** @type {((inputs?: Playdata_Pricing_League_FootnoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_League_FootnoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_league_footnote(inputs)
	return en_playdata_pricing_league_footnote(inputs)
});